import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type routeChoices = '' | 'tryhard' | 'pips' | 'edge'

interface SettingsState {
    route: routeChoices
}

const initialState: SettingsState = {
    route: ''
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setRoute: (state, action: PayloadAction<routeChoices>) => {
            state.route = action.payload;
        }
    },
    selectors: {
        getRoute: (state) => state.route
    }
})

export const {
    setRoute
} = settingsSlice.actions;

export const {
    getRoute
} = settingsSlice.selectors;

export default settingsSlice;